import { createSlice } from '@reduxjs/toolkit'
import {
  getExperiments,
  saveExperiment,
  createExperiment,
  deleteExperiment,
} from './experimentActions'

const initialState = {
  experiments: [],
  loading: false,
  loadingError: false,
  loaded: false,
  saving: false,
  savingError: false,
  saved: false,
  savedExperiment: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loadingError = false
      state.loaded = false

      state.saving = false
      state.savingError = false
      state.saved = false
      state.savedExperiment = {}

      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getExperiments.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.loadingError = null
        state.experiments = payload
      })
      .addCase(getExperiments.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.loadingError = null
      })
      .addCase(getExperiments.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.loadingError = payload
      })
      .addCase(saveExperiment.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveExperiment.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.experiments[state.experiments.findIndex((p) => p.id === payload.id)] = payload
        state.savedExperiment = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveExperiment.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createExperiment.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createExperiment.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedExperiment = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createExperiment.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteExperiment.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteExperiment.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteExperiment.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
  },
})

export const { clear } = experimentsSlice.actions
export default experimentsSlice.reducer
